<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">员工信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="工号：" required>
                  <el-input v-model="employeeData.employee_no" placeholder="工号" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名：" required>
                  <el-input v-model="employeeData.employee_name" placeholder="姓名" @Change="interviewFileChange" clearable/>
                </el-form-item>
                <el-form-item label="职位：" required>
                  <el-select v-model="employeeData.position_id" placeholder="职位" clearable>
                    <el-option v-for="item in positionList" :key="item.id" :label="item.name"
                               :value="item.id"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="职级类型：">
                  <el-select v-model="employeeData.level_type" placeholder="职级类型" clearable @change="getLevelList">
                    <el-option v-for="item in levelTypeList" :key="item.value" :label="item.label" :value="item.value"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="职级：">
                  <el-select v-model="employeeData.position_level" placeholder="职级" clearable>
                    <el-option v-for="item in levelList" :key="item.level" :label="item.title" :value="item.level"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="入职日期：" required>
                  <el-date-picker v-model="employeeData.entry_date" type="date" placeholder="选择日期"
                                  value-format="YYYY-MM-DD" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="从业日期：">
                  <el-date-picker v-model="employeeData.start_work_date" type="date" placeholder="选择日期"
                                  value-format="YYYY-MM-DD" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="手机号码：" required>
                  <el-input v-model="employeeData.phone" placeholder="手机号码"  @Change="interviewFileChange" clearable/>
                </el-form-item>
                <el-form-item label="企业邮箱：">
                  <el-input v-model="employeeData.email" placeholder="企业邮箱" clearable/>
                </el-form-item>
              </el-col>

            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="employee-photo" v-model="employeeData.photo" :init-file="employeeData.photo_obj"
                               accept="image/*" @fileChange="photoChange" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门：" required>
              <el-cascader v-model="employeeData.department_ids" :options="departmentList"
                           :props="optionProps" style="width: 100%"/>
            </el-form-item>
            <el-form-item label="角色：" required>
              <el-cascader v-model="employeeData.role_ids" :options="roleList"
                           :props="optionProps" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div style="display: flex;justify-content: space-between">
      <label style="margin-left: 5px;font-weight: bold">身份信息:</label>
    </div>
    <el-card style="margin: 5px">
      <el-form :model="idCardInfo" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="24">
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名：">
                  <el-input v-model="idCardInfo.employee_name" placeholder="姓名" clearable/>
                </el-form-item>
                <el-form-item label="民族：">
                  <el-input v-model="idCardInfo.ethnicity" placeholder="民族" clearable/>
                </el-form-item>
                <el-form-item label="出生日期：">
                  <el-date-picker v-model="idCardInfo.birthday" type="date"
                                  value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别：">
                  <el-select v-model="idCardInfo.gender" placeholder="性别" clearable>
                    <el-option label="男" value="男"/>
                    <el-option label="女" value="女"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="公民身份证号码：">
                  <el-input v-model="idCardInfo.id_card_no" placeholder="公民身份证号码" clearable/>
                </el-form-item>
                <el-form-item label="签发机关：">
                  <el-input v-model="idCardInfo.issue_authority" placeholder="签发机关" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-form-item label="住址：">
          <el-input v-model="idCardInfo.address" placeholder="住址" clearable/>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="有效期限从：">
              <el-date-picker v-model="idCardInfo.expire_date_start" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期限至：">
              <el-date-picker v-model="idCardInfo.expire_date_end" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <span>身份证正面照片</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <span>身份证反面照片</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.man_photo_show"
                               accept="image/*" :init-file="employeeData.man_photo_show_obj" @fileChange="photoChangeIdZ" :limit="1"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.nation_photo_show"
                               accept="image/*" :init-file="employeeData.nation_photo_show_obj" @fileChange="photoChangeIdF" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">合同信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同编号：">
              <el-input v-model="contractData.contract_id" placeholder="合同编号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同类型：">
              <el-select v-model="contractData.contract_type" placeholder="合同类型" clearable>
                <el-option v-for="item in contractTypeList" :key="item.id" :label="item.name"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同签订日期：">
              <el-date-picker v-model="contractData.start_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="签署公司：">
              <el-select v-model="contractData.sign_company" placeholder="签署公司" clearable>
                <el-option v-for="item in signCompanyList" :key="item.id" :label="item.name"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同生效日期：">
              <el-date-picker v-model="contractData.effect_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同结束日期：">
              <el-date-picker v-model="contractData.end_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">试用期选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否试用期：">
              <el-switch v-model="employeeData.is_probation"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划转正日期：">
              <el-date-picker type="date" value-format="YYYY-MM-DD" v-model="employeeData.probation_end_date"
                              placeholder="选择日期" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">考勤选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="参与考勤：">
              <el-switch v-model="employeeData.is_join_attendance"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">薪资选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="基本薪资：">
              <el-input-number :min="0" v-model="employeeData.salary_basic" step="1000" :precision="2"
                               placeholder="基本薪资" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="绩效工资：">
              <el-input-number :min="0" v-model="employeeData.salary_merit" step="1000" :precision="2"
                               placeholder="绩效工资" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="岗位津贴：">
              <el-input-number :min="0" v-model="employeeData.salary_job_allowance" :precision="2" step="1000"
                               placeholder="岗位津贴" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="奖金：">
              <el-input-number :min="0" v-model="employeeData.salary_award" :precision="2" step="1000"
                               placeholder="奖金" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="餐补：">
              <el-input-number :min="0" v-model="employeeData.salary_meal" :precision="2" step="100"
                               placeholder="餐补" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="话费补贴：">
              <el-input-number :min="0" v-model="employeeData.salary_phone" :precision="2" step="100"
                               placeholder="话费补贴" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">工资卡信息:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="工资卡卡号：">
                  <el-input v-model="employeeData.bank_card_no" placeholder="工资卡卡号" clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="银行：">
                  <el-select v-model="employeeData.bank_id" placeholder="银行" clearable>
                    <el-option v-for="item in bankList" :key="item.id" :label="item.name" :value="item.id"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="开户行：">
                  <el-input v-model="employeeData.account_bank" placeholder="开户行" :rows="4" type="textarea"
                            clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="照片：">
              <kf-image-upload class="avatar-uploader" v-model="employeeData.bank_card_photo"
                               accept="image/*" :init-file="employeeData.bank_card_obj" @fileChange="photoChangeBank" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">社保:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="社保配置：">
                  <el-select v-model="socialSecurityTmplData" value-key="id" placeholder="社保配置" @change="getSbBase"
                             clearable>
                    <el-option v-for="item in socialSecurityTmplList" :key="item.id" :label="item.name" :value="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="社保缴纳地：">
                  <el-input v-model="employeeData.sb_base_area" placeholder="社保缴纳地" disabled clearable/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="社保账号：">
                  <el-input v-model="employeeData.sb_card_no" placeholder="社保账号" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="缴费基数：">
                  <el-col :span="6">
                    <el-checkbox v-model="employeeData.is_custom_base" @change="setSbBase" name="self" size="small">
                      自定义
                    </el-checkbox>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="employeeData.sb_base" placeholder="缴费基数" :disabled="is_custom" clearable/>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="个人部分承担方：" v-if="employeeData.is_custom_base">
                  <el-select v-model="employeeData.sb_pay_type" placeholder="个人部分承担方" clearable>
                    <el-option v-for="item in costBoolList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="照片：">
                  <kf-image-upload class="avatar-uploader" v-model="employeeData.sb_card_photo"
                                   accept="image/*" :init-file="employeeData.sb_card_photo_obj" @fileChange="photoChangeSb" :limit="1"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">公积金:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="公积金配置：">
                  <el-select v-model="housingFundTmplData" value-key="id" placeholder="公积金配置"
                             @change="getHousingBase" clearable>
                    <el-option v-for="item in housingFundTmplList" :key="item.id" :label="item.name" :value="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="公积金缴纳地：">
                  <el-input v-model="employeeData.gjj_base_area" placeholder="公积金缴纳地" disabled clearable/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="公积金账号：">
                  <el-input v-model="employeeData.housing_fund_no" placeholder="公积金账号" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="缴费基数：">
                  <el-col :span="6">
                    <el-checkbox v-model="employeeData.is_custom_base_gjj" @change="setHousingBase" name="self"
                                 size="small">自定义
                    </el-checkbox>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="employeeData.gjj_base" placeholder="缴费基数" :disabled="is_custom_gjj"
                              clearable/>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="额外部分承担方：" v-if="employeeData.is_custom_base_gjj">
                  <el-select v-model="employeeData.gjj_pay_type" placeholder="额外部分承担方" clearable>
                    <el-option v-for="item in costBoolList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item  label="照片：">
                  <kf-image-upload class="avatar-uploader" v-model="employeeData.housing_fund_photo"
                                   accept="image/*" :init-file="employeeData.housing_fund_photo_obj" @fileChange="photoChangeHouse"
                                   :limit="1"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">学历信息:</label>
    <el-card style="margin: 5px" id="educationCard">
      <el-form :model="educationData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学历：">
              <el-select v-model="educationData.academic_degree" placeholder="学历" clearable>
                <el-option v-for="item in educationLevelList" :key="item.id" :label="item.name"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学校：">
              <el-input v-model="educationData.school" placeholder="学校" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学院：">
              <el-input v-model="educationData.college" placeholder="学院" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专业：">
              <el-input v-model="educationData.major" placeholder="专业" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间：">
              <el-date-picker v-model="educationData.entry_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="请选择" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间：">
              <el-date-picker v-model="educationData.graduation_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="请选择" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <span>毕业证书照片</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <span>学位证书照片</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="educationData.degree_certificate"
                               accept="image/*" :init-file="employeeData.degree_certificate_obj" @fileChange="photoChangeBY" :limit="1"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="educationData.graduation_certificate"
                               accept="image/*" :init-file="employeeData.graduation_certificate_obj" @fileChange="photoChangeXW" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">紧急联系人信息:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="紧急联系人姓名：">
              <el-input v-model="employeeData.emergency_name" placeholder="紧急联系人姓名" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关系：">
              <el-select v-model="employeeData.emergency_relation" placeholder="关系" clearable>
                <el-option v-for="item in emergencyRelationList" :key="item.id" :label="item.name"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :span="12" label="紧急联系人电话：">
              <el-input v-model="employeeData.emergency_contact" placeholder="紧急联系人电话" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">其它附件:</label>
    <el-row>
      <el-col :span="6" :offset="3">
        <FrameItem v-model="employeeData.attachment_ids" :item="uploadObj"></FrameItem>
      </el-col>
    </el-row>
    <div style="text-align: center">
      <el-button type="primary" :loading="loading" @click="saveEmployeeInfo">保存</el-button>
    </div>
  </el-scrollbar>
</template>

<script>

import {Plus, Upload} from "@element-plus/icons-vue";
import {Picture as IconPicture} from '@element-plus/icons-vue'
import {ref} from 'vue';
import axios from 'axios'

export default {
  name: "EmployeeEntry",
  components: {Upload, Plus, IconPicture, ref},
  inject: ['$fn'],
  setup() {
    const cameraUrl = ref('http://127.0.0.1:38088/video=stream&camidx=1');

    return {
      cameraUrl,
    };
  },
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList() {
      return this.$store.getters['core/getDictList']('bool');
    },
    costBoolList() {
      return this.$store.getters['core/getDictList']('salary_social_cost');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'id',
        label: 'name',
        checkStrictly:true,
        multiple: true,
      },
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        position_id: '',
        role_ids:[],
        // position_level:'',
        salary: '',
        gender: '',
        birthday: '',
        age: '',
        id_card_no: '',
        phone: '',
        email: '',
        address: '',
        emergency_contact: '',
        bank_card_no: '',
        is_probation: false,
        is_custom_base: false,
        is_custom_base_gjj:false,
        is_customization_subsidy: false,
        is_join_attendance: false,
        idCardInfo: {},
        contractData: {},
        salaryData: {},
        educationData: {}
      },
      dialogVisible: false,
      dialogVisibleTwo: false,
      photoType: '',
      is_custom: true,
      is_custom_gjj: true,
      idCardInfo: {},
      contractData: {},
      salaryData: {},
      educationData: {},
      eduLevelData: {},
      workExperienceData: {},
      departmentList: [],
      roleList: [],
      positionList: [],
      levelList: [],
      levelTypeList : [],
      signCompanyList: [],
      // jobLevelList: [],
      employeeTypeList: [],
      contractTypeList: [],
      bankList: [],
      socialSecurityCostList: [],
      socialSecurityBaseTypeList: [],
      socialSecurityAreaList: [],
      emergencyRelationList: [],
      educationLevelList: [],
      socialSecurityTmplData: {},
      housingFundTmplData: {},
      socialSecurityTmplList: [],
      housingFundTmplList: [],
      laborCompanyList: [],
      attendanceGroupList: [],
      loading: false,
      imageUrl: '',
      fileList: [],
      resultBoolList: [
        {value: true, name: '通过'},
        {value: false, name: '失败'}
      ],
      uploadObj: {
        component: 'file_upload',
        limit: 1,
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      }
    }
  },
  methods: {
    async getAllHRConfig(){
      await this.$http('employeeHRService.getAll').then(data => {
        this.positionList = data.employee_position
        this.emergencyRelationList = data.emergency_contacts
        this.educationLevelList = data.education_level
        this.signCompanyList = data.company
        this.contractTypeList = data.contracts_type
        this.bankList = data.bank
      })
    },
    async getLevelTypeList() {
      this.levelTypeList = await this.$http('employeeHRService.getLevelType')
    },
    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.file_id = ids;
      console.log("this.file_id", this.file_id)
    },
    //获取工号
    getEmployeeNo() {
      let params = {modelId: ""}
      this.$http('employeeInfoService.getEmployeeNo', params).then(data => {
        this.employeeData.employee_no = data;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    async loadEmployeeInfo() {
      let params = {id: this.parentData.id}
      let dbEmployee = await this.$http('employeeInfoService.getById', params);
      if (dbEmployee) {
        this.employeeData = dbEmployee;
      }
    },
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
    },
    //获取角色列表
    async getRoleList() {
      this.roleList = await this.$http('employeeInfoService.getAllRoles');
    },
    //获取个人部分社保承担放
    async getSocialSecurity() {
      let params = {modelId: "salary_social_security_cost"}
      this.socialSecurityCostList = await this.$http('employeeHRService.getAll', params);
    },
    //获取社保基数类型
    async getSocialSecurityBase() {
      let params = {modelId: "salary_base_type"}
      this.socialSecurityBaseTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取社保缴纳地
    async getSocialSecurityArea() {
      let params = {modelId: "salary_social_security_area"}
      this.socialSecurityAreaList = await this.$http('employeeHRService.getAll', params);
    },

    //获取社保模板列表
    async getSocialSecurityTmpl() {
      let params = {modelId: "salary_social_security_template"}
      this.socialSecurityTmplList = await this.$http('salaryInfoSetService.getAllSecurityTmpl', params);
    },
    //获取公积金模板列表
    async getHousingFundTmpl() {
      let params = {modelId: "salary_provident_fund_template"}
      this.housingFundTmplList = await this.$http('salaryInfoSetService.getAllHousingTmpl', params);
    },

    //获取职级
    async getLevelList() {
      this.employeeData.position_level = ''
      if (this.employeeData.level_type == null && this.employeeData.level_type === ''){
        this.$message.error("请先选择职级类型");
        return;
      }
      let params = {levelType: this.employeeData.level_type}
      this.levelList = await this.$http('employeeHRService.getLevelList',params)

    },
    getEduName(item) {
      this.eduLevelData = item;
      this.educationData.education_name = item.name;
      this.educationData.academic_degree = item.id;
    },
    getSbBase(item) {
      this.socialSecurityTmplData = item;
      this.employeeData.sb_template_id = item.id;
      this.employeeData.sb_base = item.base_pay;
      this.employeeData.sb_base_area = item.area_name;
    },
    setSbBase() {
      if (this.employeeData.is_custom_base) {
        this.is_custom = false;
      } else {
        this.is_custom = true;
      }
    },
    getHousingBase(item) {
      this.housingFundTmplData = item;
      this.employeeData.gjj_template_id = item.id;
      this.employeeData.gjj_base = item.base_pay;
      this.employeeData.gjj_base_area = item.area_name;
    },
    setHousingBase() {
      if (this.employeeData.is_custom_base_gjj) {
        this.is_custom_gjj = false;
      } else {
        this.is_custom_gjj = true;
      }
    },
    //获取二代身份证信息
    getIdCardInfo() {
      axios.get("http://127.0.0.1:38088/card=idcard").then(response => {
        if (response) {
          let params = {userInfo: response.data};
          this.$http('photoService.getIdCardInfo', params, false).then(data => {
            this.idCardInfo = data;
            if (this.idCardInfo) {
              this.idCardInfo.avatar_show = data.avatar_url;
              this.idCardInfo.avatar = data.avatar;
              this.idCardInfo.man_photo_show = data.man_photo;
              this.employeeData.man_photo_show_obj = [data.man_photo_obj];
              this.idCardInfo.nation_photo_show = data.nation_photo;
              this.employeeData.nation_photo_show_obj = [data.nation_photo_obj];
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      })
    },
    saveEmployeeInfo() {
      if (!this.employeeData.employee_name) {
        return this.$message.error("员工姓名不能为空")
      }
      if (!this.employeeData.employee_no) {
        return this.$message.error("员工工号不能为空")
      }
      if (!this.employeeData.position_id) {
        return this.$message.error("员工职务不能为空")
      }
      if (this.employeeData.level_type && !this.employeeData.position_level){
        return this.$message.error("员工职级不能为空")
      }

      /*if (this.idCardInfo) {
        if (!this.idCardInfo.employee_name) {
          return this.$message.error("身份证姓名不能为空")
        }
        if (this.idCardInfo.employee_name !== this.employeeData.employee_name) {
          return this.$message.error("身份证姓名与员工姓名不相同")
        }
        if (this.idCardInfo.expire_date_start && this.idCardInfo.expire_date_end && this.idCardInfo.expire_date_start > this.idCardInfo.expire_date_end) {
          return this.$message.error("身份证有效期结束日期不能小于开始日期");
        }
      }*/
      /*if (this.contractData && this.contractData.length > 0) {
        if (this.contractData.contract_effect_date && this.contractData.contract_expire_date && this.contractData.contract_effect_date > this.contractData.contract_expire_date) {
          return this.$message.error("合同结束日不能小于起始日");
        }
      }*/
      this.employeeData.idCardInfo = this.idCardInfo;
      this.employeeData.contractData = this.contractData;
      this.employeeData.educationData = this.educationData
      this.loading = true;
      this.$http('employeeInfoService.add', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    async photoChange(ids) {
      if (ids.length <= 0) {
        this.employeeData.photo = ''
        return
      }
      this.employeeData.photo = ids[0];
    },
    async photoChangeIdZ(ids) {
      if (ids.length <= 0) {
        this.idCardInfo.man_photo_show = ''
        return
      }
      this.idCardInfo.man_photo_show = ids[0];
    },
    async photoChangeIdF(ids) {
      if (ids.length <= 0) {
        this.idCardInfo.nation_photo_show = ''
        return
      }
      this.idCardInfo.nation_photo_show = ids[0];
    },
    async photoChangeBY(ids) {
      if (ids.length <= 0) {
        this.educationData.degree_certificate = ''
        return
      }
      this.educationData.degree_certificate = ids[0];
    },
    async photoChangeXW(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.educationData.graduation_certificate = ''
        return
      }
      this.educationData.graduation_certificate = ids[0];
    },
    async photoChangeSb(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.employeeData.sb_card_photo = ''
        return
      }
      this.employeeData.sb_card_photo = ids[0];
    },
    async photoChangeHouse(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.employeeData.housing_fund_photo = ''
        return
      }
      this.employeeData.housing_fund_photo = ids[0];
    },
    async photoChangeBank(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.employeeData.bank_card_photo = ''
        return
      }
      this.employeeData.bank_card_photo = ids[0];
    },
  },
  created() {
    this.getEmployeeNo();
    this.getDepartmentList();
    this.getRoleList();
    this.getSocialSecurity();
    this.getSocialSecurityBase();
    this.getSocialSecurityArea();
    this.getSocialSecurityTmpl();
    this.getHousingFundTmpl();
    this.getLevelTypeList();
    this.getAllHRConfig();
    this.getLevelList();
  },
}
</script>

<style lang="less">
.employee-photo {
  .el-upload-list--picture-card {
    --el-upload-list-picture-card-size: 260px;
  }

  .el-upload--picture-card {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 230px;
    height: 270px;
  }
}


.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
}

.image-slot .el-icon {
  font-size: 30px;
}

.video-thumbnail {
  position: relative;
  display: inline-block;
}

.video-thumbnail::before {
  content: "";
  position: absolute;
  top: 5%;
  left: 30%;
  width: 320px; /* 根据需要调整方框的尺寸 */
  height: 400px; /* 根据需要调整方框的尺寸 */
  background-color: rgba(0, 0, 0, 0); /* 黑色半透明背景，根据需要调整 */
  border: 2px solid red; /* 白色边框，根据需要调整 */
  box-sizing: border-box; /* 边框计算在尺寸内 */
}
</style>